var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74008 7.58495H17.1889M3.74008 12.3881H17.1889M3.25977 9.98652C3.25977 10.9327 3.44612 11.8695 3.80819 12.7437C4.17026 13.6178 4.70096 14.412 5.36998 15.081C6.039 15.7501 6.83324 16.2808 7.70736 16.6428C8.58148 17.0049 9.51835 17.1912 10.4645 17.1912C11.4106 17.1912 12.3475 17.0049 13.2216 16.6428C14.0957 16.2808 14.89 15.7501 15.559 15.081C16.228 14.412 16.7587 13.6178 17.1208 12.7437C17.4829 11.8695 17.6692 10.9327 17.6692 9.98652C17.6692 8.07571 16.9101 6.24316 15.559 4.89201C14.2079 3.54087 12.3753 2.7818 10.4645 2.7818C8.55368 2.7818 6.72113 3.54087 5.36998 4.89201C4.01883 6.24316 3.25977 8.07571 3.25977 9.98652Z",
    stroke: "white",
    strokeWidth: 1.19844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0642 2.7818C8.71559 4.94291 8.00061 7.43915 8.00061 9.98652C8.00061 12.5339 8.71559 15.0301 10.0642 17.1912M10.8647 2.7818C12.2133 4.94291 12.9283 7.43915 12.9283 9.98652C12.9283 12.5339 12.2133 15.0301 10.8647 17.1912",
    stroke: "white",
    strokeWidth: 1.19844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerWorld);
export default __webpack_public_path__ + "static/media/tabler_world.5d8981a11d01334dce14f9774791e9cf.svg";
export { ForwardRef as ReactComponent };